import { callGetApiToServer } from "../callApi";

export async function getAllSocialWorkerNeedyFamily(
  authtoken,
  workerUserId,
  skipNumber,
  limitNumber
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl =
      "v1/auth/list-social-worker-needy-family/" +
      workerUserId +
      "/" +
      skipNumber +
      "/" +
      limitNumber;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
